export enum PartRestrictFlag {
    showSecificMessage	=    'showSecificMessage',  //avec le partenaire afficher le text en haut
    noDisplay           =    'noDisplay',           //ignorer pour cw sinon ne pas afficher le partenaire dans les liste
    noRemove            =    'noRemove', 
    noChangePassword    =    'noChangePassword',
    noChangePriority    =    'noChangePriority',    //ne pas traiter 
    noChangeEnable      =    'noChangeEnable', 
    noChangeTracking    =    'noChangeTracking',    //ne pas traiter
    noChangeFlx         =    'noChangeFlx',         //ne pas changer l'association des flux
    noChangeRapp        =    'noChangeRapp',        //ne pas changer les rapports de génération
    noChangeTarif       =    'noChangeTarif',       //ne pas changer les grilles tarifaire
 
    noDisplayLogin      =    'noDisplayLogin',      //ne pas afficher le logine
    noDisplayPassword   =    'noDisplayPassword', 
    noDisplayPriority   =    'noDisplayPriority',
    noDisplayEnable     =    'noDisplayEnable',
    noDisplayTracking   =    'noDisplayTracking', 
    noDisplayFlx        =    'noDisplayFlx',
    noDisplayRapp       =    'noDisplayRapp',
    noDisplayTarif      =    'noDisplayTarif',
 
    noDisplayFtpAccess  =   'noDisplayFtpAccess',   //ne pas afficher le bloc FTP
    noDirectBuild       =   'noDirectBuild',        //ignorer
    noSave              =   'noSave',               //ne peux rien modifier

    noRestrictIfCentralWeb = 'noRestrictIfCentralWeb',  
 }